<div class="cctv-camera">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="">
                    <h4 class="cctv-title">DVR Status Not Connected</h4>
                </div>
            </div>
        </div>
    </div>
</div>

<!--================ search bar ===================-->

<section class="mis_dropdown">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="searchwidth">
                    <div class="input-group">
                        <input type="text" class="form-control misinput_control" placeholder="Search"
                            [(ngModel)]="searchTerm" (keyup)="search($event)">
                        <div class="input-group-btn">
                            <button class="btn drop_iconsearch" type="submit">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- <div class="dropfilter__flex">
                    <div class="drop__widthone">
                        <div class="dropsearch_flex">
                            <div class="dropwidth">
                                <select name="dropdown" class="mis_select" id="dropdown">
                                    <option value="STATE">State</option>
                                    <option value="CITY">City</option>
                                    <option value="CAMPUS">Campus</option>
                                </select>
                            </div>
                            <div class="searchwidth">
                                <div class="input-group">
                                    <input type="text" class="form-control misinput_control" placeholder="Search"
                                        [(ngModel)]="searchTerm" (keyup)="search($event)">
                                    <div class="input-group-btn">
                                        <button class="btn drop_iconsearch" type="submit">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown">
                        <button class="dropdown-toggle month_dropshow" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src="../../assets/image/filter.png" alt="filter" class="cctv_filter">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right mis_select_show"
                            aria-labelledby="dropdownMenuButton1">
                            <li><a class="dropdown-item">Connected</a></li>
                            <li><a class="dropdown-item">Not Connected</a></li>
                            <li><a class="dropdown-item">Video Streaming</a></li>
                            <li><a class="dropdown-item">Video Not Streaming</a></li>
                        </ul>
                    </div>
                </div> -->
            </div>
            <div class="col-md-12">
                <div class="search_mobshow">
                    <div>
                        <h6 class="mob_searchhd">Search by</h6>
                    </div>
                    <div class="searchitem_scroll">
                        <ul class="search_items">
                            <li><a href="#">Admission no </a></li>
                            <li><a href="#">School</a></li>
                            <li><a href="#">State</a></li>
                            <li><a href="#">Zone</a></li>
                            <li><a href="#">City</a></li>
                            <li><a href="#">Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- section start -->
<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="state__sec">
                    <ul class="state__list" >
                        <li *ngFor="let data of dvrnotconnected?.cctvDvrDetails| filter:searchkey:'buildingName'">
                            <div class="statelist__flex">
                                <div class="statetitle__flex">
                                    <div>
                                        <h5 class="state__name">{{data.buildingName}}
                                        </h5>
                                    </div>
                                    <div>
                                        <h6 class="state__dvr">Date : <span
                                                class="dvr__color"></span>{{data.dvrCheckDate}}
                                        </h6>
                                    </div>
                                </div>
                                <div class="">
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <div class="card-head" id="headingOne">
                                                <div class="statelist__flexx collapsed" data-toggle="collapse"
                                                    data-target="#collapseOne" aria-expanded="false"
                                                    aria-controls="collapseOne">
                                                    <div class="cctv__collapse">
                                                        <div class="dvr__border__right">
                                                            <h6 class="state__dvr">DVR No: <span
                                                                    class="dvr__color"></span>{{data.dvrNo}}</h6>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">CCTV Installed</h6>
                                                            <h5 class="cctv__number">
                                                                {{data.totalCamerasInstalled}}</h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">Connected</h6>
                                                            <h5 class="cctv__number">{{data.totalConnected}}
                                                            </h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">Not Connected</h6>
                                                            <h5 class="cctv__number">{{data.totalNotConnected}}
                                                            </h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">Streaming</h6>
                                                            <h5 class="cctv__number">
                                                                {{data.totalVideoStreaming}}</h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">No Video</h6>
                                                            <h5 class="cctv__number">
                                                                {{data.totalVideoNotStreaming}}</h5>
                                                        </div>
                                                        <div>
                                                            <!-- <a routerLink="/building/{{data.buildingId}}" h
                                                                ref="#"><button type="button"
                                                                    class="cctv_livebtn">Live</button></a> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-expansion-panel-header>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="cctv_video_show">
                                                        <ul class="video-image"
                                                            *ngFor="let frame of data.cctvFrameURLList">
                                                            <li>
                                                                <div class="video_width">
                                                                    <button class="btn-1"  (click)="openvideostreaming(frame)">
                                                                        <figure class="mb-0">
                                                                            <img [src]="frame.cctvFrameUrl"
                                                                                class="cctvimg" alt="cctvimg missing">
                                                                        </figure>
                                                                        <p class="cctv_camno">C
                                                                            :{{frame.channelsNo}}
                                                                        </p>
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!--================== loader ==============-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>